import { render, staticRenderFns } from "./BizTransformService.vue?vue&type=template&id=33ebbec8&scoped=true"
import script from "./BizTransformService.vue?vue&type=script&lang=js"
export * from "./BizTransformService.vue?vue&type=script&lang=js"
import style0 from "./BizTransformService.vue?vue&type=style&index=0&id=33ebbec8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ebbec8",
  null
  
)

export default component.exports